import Link from 'components/Link'
import PropTypes from 'prop-types';

const LinkListItem = {};

LinkListItem.propTypes = Object.assign({}, Link.propTypes, {
    isActive: PropTypes.bool
});

export default LinkListItem;